import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from './DropdownMenu.module.scss';

type DropdownMenuItemProps = PropsWithChildren<{
  disabled?: boolean;
  className?: string;
  'data-test'?: string;
  divider?: 'top';
  onClick?: () => void;
}>;

const DropdownMenuItem: FC<DropdownMenuItemProps> = ({
  children,
  disabled,
  className,
  onClick,
  divider,
  ...props
}) => {
  const _className = classNames(
    styles.itemDropdownMenu,
    {
      disabled,
      [styles.topDivider]: divider === 'top',
    },

    className,
  );

  return (
    <li className={_className}
        onClick={onClick}
        data-test={props['data-test']}>
      {children}
    </li>
  );
};

export default DropdownMenuItem;
